import Vue from 'vue'
import axios from 'axios'

let el = document.querySelector('#award-view')
if(el) new Vue({
    el,
    components: {
        
    },
    data() {
        return {
            loading: true,
            failed: false,
            page: 1,
            per_page: 15,
            awards: [],
            pagination: {},
        }
    },
    computed: {
        limit() {
            return this.page * this.per_page
        },
        next() {
            return this.awards.length > this.limit 
        }
    },
    filters: {

    },
    methods: {
        setLimit(limit = 15) {
            this.page = 1
            this.per_page = limit
        },
        getAwards() {
            this.loading = true
            this.failed = false
            axios.get(`/wp-json/wp/v2/award?per_page=100`).then(response => {
                let priority_awards = [], regular_awards = [];
                response.data.forEach(award => {
                    if(award.acf.show_first) {
                        priority_awards.push(award)
                    } else {
                        regular_awards.push(award)
                    }
                })
                this.awards = priority_awards.concat(regular_awards)
                this.loading = false
            }).catch(() => {
                this.loading = false
                this.failed = true
            })
        },
        getBackground(award) {
            let url = false
            if(award.acf.photo) url = award.acf.photo.sizes.large
            if(award.acf.thumbnail_image) url = award.acf.thumbnail_image.sizes.large
            if(url) return `url('${url}')`
            return false
        },
        showMore() {
            this.page++
        }
    },
    mounted() {
        this.getAwards()
    }
})



// WEBPACK FOOTER //
// ./assets/js/components/_award.js